import React, { useState } from 'react'

import useSingleton from '../../../business-components/useSingleton/useSingleton'

import LABEL from '../../../business-const/Label/Label'

import MESSAGE from '../../../business-const/Message/Message'

import TAMMAX from '../../../business-rules/TamMax/TamMax'

import {
    dataAtual,
    difDatasDias,
    formataDataHora,
} from '../../../business-components/Date/Date'

import {
    DivForm,
} from '../../../business-components/Div/Div'

import {
    CardGridEntradaDados,
    CardGridDividerElementos,
    CardGridDivBodyEntradaDados,
} from '../../../business-components/Card/Card'

import {
    GridContainer,
    GridItem1,
    GridItem3,
    GridItem4,
    GridItem5,
    GridItem8,
    GridItem9,
    GridItem11,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import { 
    TextValidatorText,
} from '../../../business-components/TextValidator/TextValidator'

import {
    CheckboxPadrao
} from '../../../business-components/Checkbox/Checkbox'

import { 
    MuiPickersUtilsProviderPadrao,
    KeyboardDateTimePickerPadraoRequired,
} from '../../../business-components/MuiPickers/MuiPickers'

import {
    //ButtonPadrao,
    ButtonGerarLinkCliente,
    //ButtonGerarLinkClienteDisabled,
    ButtonAlterarConfiguracaoRelatorio,
} from '../../../business-components/Button/Button'

import {
    IconButtonCopiar,
} from '../../../business-components/IconButton/IconButton'

import {
    CustomizedDialogsPopup,
} from '../../../business-components/Dialog/CustomizeDialogs'

import {
    inicializaConfiguracaoRelatorio,
} from '../estudo-parametros/EstudoServiceConfiguracaoRelatorio'

import {
    calculaConfiguracaoPerguntas,
} from '../form-form/FormServicePerguntas'

import {
    processaValoresDefaultIniciaisGerarLinkCliente,
    dataHoraValidadeLinkMaxima,
    dataHoraValidadeLinkValida,
    gerarLinkCliente,
} from './CadastroServiceGerarLinkCliente'

import {
    Template,
} from '../estudo-parametros/EstudoCompConfiguracao'

import {
    Formulario
} from '../form-form/FormCompPergunta'

import EstudoReportPrimeiraReuniaoClienteConfiguracao from '../estudo-report/EstudoReportPrimeiraReuniaoClienteConfiguracao'

import EstudoFormConfiguracaoRelatorio from '../estudo-parametros/EstudoFormConfiguracaoRelatorio'



const CadastroFormGerarLinkCliente = ( {variaveisGlobais, values, handleChange, handleSubmit, setFieldValue, linhaTipoLicenca,
    jsonPagina, jsonUsuario, jsonUsuarioAdmin, linhaFormList} ) => {

    const [formularioList, setFormularioList] = useState(null)
    const [templateList, setTemplateList] = useState(null)

    const [processing, setProcessing] = useState(false)

    useSingleton(() => {

        const formularioListAux = calculaConfiguracaoPerguntas(variaveisGlobais, values, linhaFormList,
            jsonUsuario, jsonUsuarioAdmin, false/*jsonIntegracao*/)
                
        setFormularioList(formularioListAux)

        inicializaConfiguracaoRelatorio(variaveisGlobais, values, values.idFormList, linhaTipoLicenca, jsonPagina,
            jsonUsuario, jsonUsuarioAdmin, setTemplateList)

        processaValoresDefaultIniciaisGerarLinkCliente(values)
    })

    return (
        <div
            className={'ml-4 mr-4'}
        >
            <DivForm>
                <GridContainer>
                    <GridItem12>
                        <CardGridEntradaDados>
                            <CardGridDivBodyEntradaDados>
                                {!values.disponibilizarRelatorioSimulacaoFinanceira &&
                                !values.disponibilizarRelatorioEstudo && (
                                    <>
                                        <GridContainer>
                                            <GridItem5
                                                className='mt-3'
                                            >
                                                <CheckboxPadrao
                                                    name="disponibilizarInclusaoRevisaoDadosBasicos"
                                                    label={LABEL.disponibilizarInclusaoRevisaoDadosBasicos}
                                                    checked={values.disponibilizarInclusaoRevisaoDadosBasicos}
                                                    onChange={handleChange}
                                                />
                                            </GridItem5>

                                            {values.disponibilizarInclusaoRevisaoDadosBasicos && (
                                                <GridItem4>
                                                    <Formulario
                                                        values={values}
                                                        handleChange={handleChange}
                                                        linhaFormList={linhaFormList}
                                                        completo={''}
                                                        formularioList={formularioList}
                                                        setPrimInd={''}
                                                    />
                                                </GridItem4>
                                            )}
                                        </GridContainer>

                                        {values.disponibilizarInclusaoRevisaoDadosBasicos &&
                                        (jsonUsuario.utilizarEstudoCompleto || jsonUsuario.permitirInformarRiscos) && (
                                            <GridContainer>
                                                <GridItem5
                                                    className='mt-3'
                                                >
                                                    <CheckboxPadrao
                                                        name="disponibilizarInclusaoRevisaoRiscos"
                                                        label={LABEL.disponibilizarInclusaoRevisaoRiscos}
                                                        checked={values.disponibilizarInclusaoRevisaoRiscos}
                                                        onChange={handleChange}
                                                    />
                                                </GridItem5>
                                            </GridContainer>
                                        )}

                                        <CardGridDividerElementos/>
                                    </>
                                )}

                                {linhaTipoLicenca.exibirSimulacaoFinanceira === "S" &&
                                !values.disponibilizarInclusaoRevisaoDadosBasicos && (
                                    <>
                                        <GridContainer>
                                            <GridItem5
                                                className='mt-3'
                                            >
                                                <CheckboxPadrao
                                                    name="disponibilizarRelatorioSimulacaoFinanceira"
                                                    label={LABEL.disponibilizarRelatorioSimulacaoFinanceira}
                                                    checked={values.disponibilizarRelatorioSimulacaoFinanceira}
                                                    onChange={handleChange}
                                                />
                                            </GridItem5>

                                            {values.disponibilizarRelatorioSimulacaoFinanceira && (
                                                <GridItem3
                                                    className='mt-4'
                                                >
                                                    <CustomizedDialogsPopup
                                                        maxWidth='lg'
                                                        popupTitle={LABEL.buttonAlterarConfiguracaoRelatorio}
                                                        PopupButton={ButtonAlterarConfiguracaoRelatorio}
                                                        bgDefault={true}
                                                        popupComponent={
                                                            <div
                                                                className='ml-4 mr-4'
                                                            >
                                                                <EstudoReportPrimeiraReuniaoClienteConfiguracao
                                                                    values={values}
                                                                    handleChange={handleChange}
                                                                    handleSubmit={handleSubmit}
                                                                    linhaTipoLicenca={linhaTipoLicenca}
                                                                    linhaFormList={linhaFormList}
                                                                />
                                                            </div>
                                                        }
                                                    />
                                                </GridItem3>
                                            )}
                                        </GridContainer>

                                        <CardGridDividerElementos/>
                                    </>
                                )}

                                
                                {linhaTipoLicenca.exibirCompleto/*exibirEstudo*/ === "S" &&
                                !values.disponibilizarInclusaoRevisaoDadosBasicos && (
                                    <>
                                        <GridContainer>
                                            <GridItem5
                                                className='mt-3'
                                            >
                                                <CheckboxPadrao
                                                    name="disponibilizarRelatorioEstudo"
                                                    label={LABEL.disponibilizarRelatorioEstudo}
                                                    checked={values.disponibilizarRelatorioEstudo}
                                                    onChange={handleChange}
                                                />
                                            </GridItem5>

                                            {values.disponibilizarRelatorioEstudo && (
                                                <>
                                                    <GridItem4>
                                                        <Template
                                                            values={values}
                                                            handleChange={handleChange}
                                                            templateList={templateList}
                                                            linhaTipoLicenca={linhaTipoLicenca}
                                                            jsonPagina={jsonPagina}
                                                        />
                                                    </GridItem4>

                                                    <GridItem3
                                                        className='mt-4'
                                                    >
                                                        <CustomizedDialogsPopup
                                                            maxWidth='lg'
                                                            popupTitle={LABEL.buttonAlterarConfiguracaoRelatorio}
                                                            PopupButton={ButtonAlterarConfiguracaoRelatorio}
                                                            bgDefault={true}
                                                            popupComponent={
                                                                <div
                                                                    className='ml-4 mr-4'
                                                                >
                                                                    <EstudoFormConfiguracaoRelatorio
                                                                        variaveisGlobais={variaveisGlobais}
                                                                        values={values}
                                                                        handleChange={handleChange}
                                                                        handleSubmit={handleSubmit}
                                                                        setFieldValue={setFieldValue}
                                                                        linhaTipoLicenca={linhaTipoLicenca}
                                                                        jsonPagina={jsonPagina}
                                                                        jsonUsuario={jsonUsuario}
                                                                        jsonUsuarioAdmin={jsonUsuarioAdmin}
                                                                    />
                                                                </div>
                                                            }
                                                        />
                                                    </GridItem3>
                                                </>
                                            )}
                                        </GridContainer>

                                        <CardGridDividerElementos/>
                                    </>
                                )}

                                {/* -- inativado temporariamente até que fique pronta a opção de upload de arquivos pelos clientes finais
                                <GridContainer>
                                    <GridItem12
                                        className='mt-3'
                                    >
                                        <CheckboxPadrao
                                            name="disponibilizarAcompanhamento"
                                            label={LABEL.disponibilizarAcompanhamento}
                                            checked={values.disponibilizarAcompanhamento}
                                            onChange={handleChange}
                                        />
                                    </GridItem12>
                                </GridContainer>

                                <CardGridDividerElementos/>
                                */}

                                <GridContainer>
                                    <GridItem3>
                                        <GridContainer>
                                            <GridItem8>
                                                <MuiPickersUtilsProviderPadrao>
                                                    <KeyboardDateTimePickerPadraoRequired
                                                        name="dataHoraValidadeLink"
                                                        label={LABEL.dataHoraValidadeLink}
                                                        value={values.dataHoraValidadeLink}
                                                        onChange={(date) => {
                                                            setFieldValue(
                                                                'dataHoraValidadeLink',
                                                                date,
                                                            )}
                                                        }
                                                    />
                                                </MuiPickersUtilsProviderPadrao>
                                            </GridItem8>

                                            {/*
                                            <GridItem12>
                                                <ButtonPadrao
                                                    label={LABEL.buttonGerarLinkCliente}
                                                    align='left'
                                                    onClick={async () => {
                                                        setProcessing(true)
                                                        const linkCliente = await gerarLinkCliente(variaveisGlobais, values)
                                                        setFieldValue(
                                                            "linkCliente",
                                                            linkCliente
                                                        )
                                                        setProcessing(false)
                                                    }}
                                                    disabled={
                                                        (!values.disponibilizarInclusaoRevisaoDadosBasicos &&
                                                        !values.disponibilizarRelatorioSimulacaoFinanceira &&
                                                        !values.disponibilizarRelatorioEstudo &&
                                                        !values.disponibilizarAcompanhamento) ||
                                                        !dataHoraValidadeLinkValida(values)
                                                    }
                                                />
                                            </GridItem12>
                                            */}
                                            <GridItem12>
                                                <CustomizedDialogsPopup
                                                    maxWidth='md'
                                                    popupTitle={LABEL.linkCliente}
                                                    PopupButton={ButtonGerarLinkCliente}
                                                    //    (!values.disponibilizarInclusaoRevisaoDadosBasicos &&
                                                    //    !values.disponibilizarRelatorioSimulacaoFinanceira &&
                                                    //    !values.disponibilizarRelatorioEstudo &&
                                                    //    !values.disponibilizarAcompanhamento) ||
                                                    //    !dataHoraValidadeLinkValida(values)
                                                    //        ?
                                                    //            ButtonGerarLinkClienteDisabled
                                                    //        :
                                                    //            ButtonGerarLinkCliente
                                                    //}
                                                    //bgDefault={true}
                                                    popupComponent={
                                                        <GridContainer>
                                                            {!processing && (
                                                                <>
                                                                    <GridItem11>
                                                                        <TextValidatorText
                                                                            name="linkCliente"
                                                                            label={LABEL.linkCliente}
                                                                            value={values.linkCliente || ''}
                                                                            onChange={handleChange}
                                                                            tamMax={TAMMAX.linkCliente}
                                                                            notToUpperCase={true}
                                                                            disabled={true}
                                                                        />
                                                                    </GridItem11>

                                                                    <GridItem1>
                                                                        <IconButtonCopiar
                                                                            value={values.linkCliente}
                                                                        />
                                                                    </GridItem1>

                                                                    <GridItem12>
                                                                        <h5
                                                                            className='mt-4'
                                                                            dangerouslySetInnerHTML={{ __html:
                                                                                MESSAGE().linkClienteComoUtilizar
                                                                            }}
                                                                        />
                                                                        <div
                                                                            className='mt-10'
                                                                            dangerouslySetInnerHTML={{ __html:
                                                                                MESSAGE().linkClienteValidade
                                                                                    .replace("$1$", difDatasDias(dataAtual(), values.dataHoraValidadeLink))
                                                                            }}
                                                                        />
                                                                    </GridItem12>
                                                                </>
                                                            )}
                                                            
                                                            {processing && (
                                                                <GridItem9>
                                                                    <h1
                                                                        className='mt-4'
                                                                    >
                                                                        {LABEL.gerandoLinkCliente}
                                                                    </h1>
                                                                </GridItem9>
                                                            )}
                                                        </GridContainer>
                                                    }
                                                    onOpen={async () => {
                                                        setProcessing(true)
                                                        const linkCliente = await gerarLinkCliente(variaveisGlobais, values)
                                                        setFieldValue(
                                                            "linkCliente",
                                                            linkCliente
                                                        )
                                                        setProcessing(false)
                                                    }}
                                                    disabled={(!values.disponibilizarInclusaoRevisaoDadosBasicos &&
                                                        !values.disponibilizarRelatorioSimulacaoFinanceira &&
                                                        !values.disponibilizarRelatorioEstudo &&
                                                        !values.disponibilizarAcompanhamento) ||
                                                        !dataHoraValidadeLinkValida(values)
                                                    }
                                                />
                                            </GridItem12>
                                        </GridContainer>
                                    </GridItem3>
                                
                                    {/*processing && (
                                        <GridItem9>
                                            <h1
                                                className='mt-4'
                                            >
                                                {LABEL.gerandoLinkCliente}
                                            </h1>
                                        </GridItem9>
                                    )*/}

                                    {!dataHoraValidadeLinkValida(values) && (
                                        <GridItem9>
                                            <h5
                                                className='mt-6'
                                            >
                                                {LABEL.dataHoraValidadeMaxima.replace('$1$',
                                                    formataDataHora(dataHoraValidadeLinkMaxima(values)))}
                                            </h5>
                                        </GridItem9>
                                    )}

                                    {/*!processing && values.linkCliente && dataHoraValidadeLinkValida(values) && (
                                        <GridItem9>
                                            <TextValidatorText
                                                name="linkCliente"
                                                label={LABEL.linkCliente}
                                                value={values.linkCliente || ''}
                                                onChange={handleChange}
                                                tamMax={TAMMAX.linkCliente}
                                                notToUpperCase={true}
                                                disabled={true}
                                            />
                                        </GridItem9>
                                    )*/}
                                </GridContainer>
                            </CardGridDivBodyEntradaDados>
                        </CardGridEntradaDados>
                    </GridItem12>
                </GridContainer>
            </DivForm>
        </div>
    )
}

export default CadastroFormGerarLinkCliente